import * as React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';
import { __, __r } from 'react-i18n';
import { ButtonLink } from '../General/Button';
import { TextP, TitleMedium } from '../General/Text';

interface Props {
  title: string;
  description: string;
  redirectUrl: string;
}

export const BlogPreview = ({ title, description, redirectUrl }: Props) => {
  return (
    <Wrapper>
      <Content>
        <Title>{`${title}`}</Title>
        <Text>{`${description}`}</Text>
        <DesktopBlogButtonLink to={redirectUrl}>
          {__('Prejsť na blog')}
        </DesktopBlogButtonLink>
      </Content>
    </Wrapper>
  );
};

// obrazok banneru musi obsahovat aj farbu
const Wrapper = styled.section`
  max-width: ${rem(328)};
  flex: 1 0 auto;
  background-color: ${({ theme }) => theme.colors.white};
  position: relative;
  height: 100%;

  ${({ theme }) => theme.mediab.l925`
    margin-bottom: ${rem(32)};
  `}

  ${({ theme }) => theme.media(0, 'sm')} {
    margin-bottom: 0;
  }
`;

const Content = styled.article`
  ${({ theme }) => theme.mediab.l925`
    text-align: center;
  `}
`;

const Title = styled(TitleMedium)`
  margin-bottom: ${rem(32)};
  text-transform: uppercase;
`;

const Text = styled(TextP)`
  margin-bottom: ${rem(32)};
`;

const DesktopBlogButtonLink = styled(ButtonLink)`
  ${({ theme }) => theme.media(0, 'sm')} {
    display: none;
  }

  &:hover,
  &:focus {
    background: ${({ theme }) => theme.colors.primaryOnHover};
    outline: none;
  }
`;
